export default [
  {
    title: '代理商ID',
    key: 'id',
    width: 48
  },
  {
    title: '代理商名称',
    key: 'agentName'
  },
  {
    title: '开票主体',
    key: 'field3'
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 110
  },

  {
    title: '创建人',
    key: 'createOpName',
    width: 60
  },
  {
    title: '更新人',
    key: 'updateOpName',
    width: 60
  },
  {
    title: '更新时间',
    key: 'upTime',
    width: 110
  },
  {
    title: '操作',
    key: 'control',
    width: 40
  }
]
